import { format } from "date-fns";
import { X } from "lucide-react";

import { Button } from "components/ui/Button";
import { Pill } from "components/ui/Pill";
import { CdmPreviewContent } from "features/cdm/cdm/components/CDMPreview/CdmPreviewContent";
import { useGetCDM } from "features/cdm/cdm/hooks/useGetCDM";
import { getReviewTypeTitle } from "features/cdm/constants/reviewTypes";
import { views } from "features/cdm/hooks/useView";
import { formatCdmStatus, getCdmStatusColors } from "utils/cdmStatus";

import { CdmMessagePreview } from "../CdmMessagePreview/CdmMessagePreview";
import { LoadingSection } from "../LoadingSection/LoadingSection";
import style from "./DeregistrationPreview.module.css";

const formatDate = (value) => {
  if (!value) return "-";
  const date = new Date(value);
  return Number.isNaN(date.getTime()) ? "-" : format(date, "dd-MM-yyyy");
};

// Deregistration reviews come back as a compact audit snapshot rather than a
// full clinical dataset, so they get a dedicated read-only view: the standard
// Healthlink submission-status section plus the HL7 message preview.
export const DeregistrationPreview = ({ item, setView }) => {
  const { data, isLoading } = useGetCDM(item?.id);

  if (!item) {
    return null;
  }

  if (!data || isLoading) {
    return <LoadingSection />;
  }

  const statusColors = getCdmStatusColors(data.status);

  return (
    <section className={style.wrapper}>
      <div className={style.header}>
        <div className={style.headerInner}>
          <h3>{getReviewTypeTitle(item.reviewType)}</h3>
          <Pill
            color={statusColors.color}
            bg={statusColors.bg}
            border={statusColors.border}
          >
            {formatCdmStatus(data.status)}
          </Pill>
          <p>{formatDate(data.reviewDate ?? item.reviewDate)}</p>
        </div>
        <Button
          variant="outlineGray"
          iconButton
          onClick={() => setView({ name: views.noChronicDiseases, cdmId: null })}
          aria-label="Close preview"
        >
          <X size={16} />
        </Button>
      </div>

      <div className={style.messagePreview}>
        <CdmMessagePreview xml={data.clinicalMessageXml} />
      </div>
      <CdmPreviewContent data={data} />
    </section>
  );
};
